import React, { useState } from "react";
import { scan } from "../api/api";
import ResponseDialog from "./dialog/ResponseDialog";

const Scanner = () => {
    const [inputScanName, setInputScanName] = useState("");
    const [selectScanType, setSelectScanType] = useState("");
    const [typemessage, setTypemessage] = useState("");
    const [resmessage, setResmessage] = useState("");

    const formData = {
        inputScanName,
        selectScanType
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setTypemessage("info");
        setResmessage("Scanning...");

        const response = await scan(formData);
        setTypemessage(response.type);
        if (response.type === "success") {
            setInputScanName("");
            setSelectScanType("");
        }
        setResmessage(response.message);
    };

    return(
      <div className="card">
        <div className="card-header">
          <h5>Scanner</h5>
        </div>
        <div className="card-body">
          {typemessage && resmessage && <ResponseDialog type={typemessage} message={resmessage} onClose={() => setResmessage("")} />}
            
          <div className="row">
            <div className="col-md-12">
              <form onSubmit={handleSubmit} method="post">
                <div className="form-group">
                  <label htmlFor="inputScanName">Name</label>
                  <input type="text" className="form-control" id="inputScanName" name="inputScanName" placeholder="Enter name"
                    value={inputScanName}
                    onChange={(e) => setInputScanName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="selectScanType">Type</label>
                  <select className="form-control" id="selectScanType" name="selectScanType" required
                    value={selectScanType}
                    onChange={(e) => setSelectScanType(e.target.value)}
                  >
                    <option value>-- Select type --</option>
                    <option value="jpeg">jpeg</option>
                    <option value="png">png</option>
                    <option value="pdf">pdf</option>
                  </select>
                </div>
                <div className="form-group">
                  <button type="submit" className="btn  btn-primary">SCAN!</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
}
export default Scanner;